module.exports = __webpack_public_path__ + "img/star1.57523c6e.svg";